export default "__VITE_ASSET__ktQxlles__"